export const BULK_ALERT = {
  BULK_IMPORT_EXPORT_TITLE: 'Bulk Export',
  BULK_EXPORT_TITLE: 'EXPORT',
  BULK_EXPORT_CAPTION: 'All fields are required unless noted as optional.',
  BULK_EXPORT_RADIO: 'Select purpose of indent',
  BULK_EXPORT_SELECT: 'For Item type',
  BULK_EXPORT_SELECT_ERROR: 'Item type list could not be found.',
  BULK_EXPORT_NO_RESULTS: 'No results found.',
  BULK_EXPORT_BUTTON: 'Download Excel File',
  BULK_EXPORT_IN_PROGRESS_BUTTON: 'FILE PROCESSING',
  BULK_EXPORT_SUCCESS: (itemType) =>
    `Spreadsheet for item type '${itemType}' has been downloaded successfully!`,
  BULK_EXPORT_ERROR:
    "File processing failed! Click on 'Download Excel File' again.",
  BULK_EXPORT_ITEM_NOT_FOUND: 'No items found for the selected Item type.',
  BULK_EXPORT_ITEM_TYPE_LOAD_INTIALLY: 'Failed to load item type',
  BULK_EXPORT_RADIO_LIST: [
    {
      label: 'Blank Template ',
      subText:
        '/ View comprehensive list of attributes required to setup an item for specific item type',
      value: 'blank',
      disable: false,
    },
    {
      label: 'All item data in LaunchPad ',
      subText:
        '/ Perform an audit as part of data quality compliance or any other review',
      value: 'all',
      disable: false,
    },
  ],
  BULK_IMPORT_TITLE: 'BULK IMPORT',
  BULK_IMPORT_BUTTON: 'Upload Excel File',
  BULK_IMPORT_FILE_NAME: 'File Name',
  BULK_IMPORT_DROP_NAME: 'dropzoneText',
  BULK_MAX_TOOLTIP_TEXT: 'Max. Limit 35k',
  BLK_EXPORT_IN_PROGRESS_BUTTON: 'FILE PROCESSING',
}
